import React from 'react';
import { Modal, Button, Upload, Table, message } from 'antd';
import upload from '../../images/upload.svg'
import successIcon from '../../images/successicon.svg'
import warningIcon from '../../images/warningicon.svg'
import errorIcon from '../../images/erroricon.svg'
import './index.css';

class importModal extends React.Component {
  constructor(){
    super();
    this.state = {
      modalShow : "import",
      type : "import",
      fileList : [],
      file : ""
    }
  }
  clearSeach = () => {

  }
  submitSearch = (value) => {
    this.props.getSearch({
      pname : value
    });
  }
  handleChange = ({ file, fileList }) => {
    const result = file.response;
    const obj = this;
    if(result) {
      switch(result.retCode){
        case 0:
          this.setState({ fileList }, function(){
            this.setState({ type : 'ing' });
            window.setTimeout(function(){
              obj.setState({
                fileList,
                type : 'success'
              });
            }, 2000);
          });
          break;
        case 1:
          this.setState({ fileList : [] });
          message.warning(result.retMsg);
          break;
        default:
          this.setState({ fileList : [] });
          message.warning(result.retMsg);
          break;
      }
    } else {
      this.setState({ fileList });
    }
  }
  render(){
    const { modalType } = this.props;
    const { modalShow, type, fileList } = this.state;
    // const fileList = [{
    //   uid: 123,
    //   name: "2018年上海交通大学新生",
    //   status: "done",
    // }]
    let title = "";
    let footer = false;
    switch(type){
      case "import":
        title = "导入信息";
        footer = <div>
          <Button onClick={ this.handleOk }>取消</Button>
          <Button onClick={ this.props.showModal.bind(this, "") }>确定</Button>
        </div>
        break;
      default:
        title = "提示";
        footer = false;
        break;
    }
    return (
      <Modal
        className="uploadModal"
        visible={ modalType === modalShow }
        title={ title }
        onOk={ this.handleOk }
        onCancel={ this.props.showModal.bind(this, "") }
        footer={ footer }
      >
        {type === "success" && <div className="text-center">
          <div>
            <img src={ successIcon } alt="" />
            <div className="mt-24">导入成功</div>
            <Button type="primary" className="mt-24" onClick={ this.props.showModal.bind(this, "importend") }>确定</Button>
            { /*<div className="">您还需要发布数据到设备</div>*/ }
            {/*<div className="mt-16"><Button type="primary" onClick={ this.props.showModal.bind(this, "release")}>发布</Button></div>*/}
            {/* <div className="mt-16"><Button type="primary" onClick={ this.props.showModal.bind(this, "release")}>发布</Button></div>*/}
          </div>
        </div>}
        {type === "error" && <div className="text-center">
          <div>
            <img src={ errorIcon } alt=""/>
            <div className="mt-24">部分导入出错</div>
            <div className="text-left">您还需要发布数据到设备</div>
            <div className="mt-16">
              <ImportTable />
            </div>
            <div className="mt-16">
              <Button type="primary" onClick={ this.props.showModal.bind(this, "") }>确定</Button>
            </div>
          </div>
        </div>}
        {type === "ing" && <div className="text-center modal-impoting-content">
          <div>
            <img src={ warningIcon } alt=""/>
            <span>正在导入，请不要刷新页面，耐心等待…</span>
          </div>
        </div>}
        {type === "import" && <div>
          <div className="text-center">
            <div className="upload-main">
              <Upload
                action="/api/upload_batch"
                name="file"
                fileList={ fileList }
                onChange={this.handleChange}
                onRemove={this.handleonRemove}
                beforeUpload={ this.beforeUpload }
              >
                { fileList.length === 0 ?
                  <div className="upload-btn">
                    <img src={ upload } alt=""/>
                    <div className="mt-8">点击选择上传表格</div>
                  </div> :
                  ""
                }
              </Upload>
            </div>
          </div>
          <div className="mt-18 text-left">
            <div className="care-tip">
              <div className="care-tip-title">注意事项：</div>
              <div className="care-tip-one">1、必须按照制定的模板格式才能导入成功</div>
              <div className="care-tip-one">2、如果Excel中数据已存在，则会覆盖原有信息</div>
              <div className="care-tip-one">3、请勿修改导入模板中的信息，填入学工号对应的实体卡卡号信。</div>
              <div className="mt-18">下载模板：<a href="http://campusdb.iyunban.com:3302/static/doc/upload_test_shnu.csv">门禁实体卡导入模板</a></div>
            </div>
          </div>
        </div>}
      </Modal>
    )
  }
}

class ImportTable extends React.Component {
  render(){
    const dataSource = [{
      key: '1',
      name: '胡彦斌',
      age: 32,
      address: '西湖区湖底公园1号'
    }, {
      key: '2',
      name: '胡彦祖',
      age: 42,
      address: '西湖区湖底公园1号'
    }];

    const columns = [{
      title: '门名称',
      dataIndex: 'name',
      key: 'name',
    }, {
      title: '学号',
      dataIndex: 'age',
      key: 'age',
    }, {
      title: '姓名',
      dataIndex: 'address',
      key: 'address',
    }, {
      title: '实体卡号',
      dataIndex: 'card',
      key: 'address',
    }, {
      title: '失败原因',
      dataIndex: 'error',
      key: 'address',
    }];
    return (
      <Table dataSource={dataSource} columns={columns} footer={ false } size="small"/>
    )
  }
}
export default importModal;



// WEBPACK FOOTER //
// ./src/component/manage/importmodal.js